/**
 * useOutreachRates — one page of the CRM's Rates list
 * (GET /campaigns/{id}/outreach/rates), keyed by every param so each
 * search/page is its own cache slot. useOutreachSSE refreshes it when a rate
 * is agreed or an entry changes.
 */
import { useQuery } from '@tanstack/react-query';
import type { OutreachRatesPage } from '@discovr/types';
import { campaignKeys } from '../queryKeys';
import { retryOutreachQuery } from './outreachRetry';
import { fetchOutreachRates, type OutreachRatesParams } from '../api/outreachApi';

const RATES_STALE_MS = 30_000;

export function useOutreachRates(campaignId: string, params: OutreachRatesParams, enabled = true) {
  return useQuery<OutreachRatesPage>({
    queryKey: campaignKeys.outreachRates(campaignId, params),
    queryFn: () => fetchOutreachRates(campaignId, params),
    enabled: enabled && !!campaignId,
    staleTime: RATES_STALE_MS,
    retry: retryOutreachQuery,
  });
}
